import ReportImages from "./imagesAndTags"
import signalAILogo from "../../../assets/illustrations/signal-AI.png"
import ScoreGauge from "./score"
import "../signal.css"
import { calculateMeanScore } from "../../../Utils/signalAIScoreCalculation"
import { useNavigate } from "react-router-dom"
import { postLogDetails } from "../../../Services/APIs/appDetails"
import { useEffect } from "react"

const SignalAIResult = () => {
    const navigate = useNavigate();
    const uid = JSON.parse(localStorage.getItem("usertpi") || '{}').usertpi
    const app = JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket

    // Get data once and pass as parameters for better performance
    const tpscore = JSON.parse(localStorage.getItem("tpscore") || "{}");

    // Calculate mean score out of 100 using cavity, tartar, gum, and gap scores
    const overallScore = calculateMeanScore(tpscore);

    useEffect(() => {
        postLogDetails({ uid, app, payLoad: `Result page loaded, overall score: ${overallScore}` })
    }, [])

    const goToSummary = () => {
        postLogDetails({ uid, app, payLoad: `View summary clicked from result page` })
        navigate("/signalai_wohd/summary");
    };

    return (
        <div className="px-5 h-full signal-ai-bg-image border border-white flex flex-col">
            <div className="flex-1">
                <img src={signalAILogo} alt="Signal AI Logo" className="h-24 mx-auto mt-6" />
                <div className=" text-signal-ai-blue shadow-lg rounded-md bg-gradient-to-t from-white to-transparent mb-5 font-medium py-3">
                    <p className="text-base px-5">သင့်ရဲ့သွား ကျန်းမာရေးအခြေအနေ</p>
                    <p className="text-base px-5">သုံးသပ်ချက်အကျဉ်းချုပ်</p>
                    {(!tpscore || Object.keys(tpscore).length === 0) ? (
                        <div className="text-center py-4">
                            <p className="text-lg text-red-600 font-medium">
                                အင်တာနက်ချို့ယွင်းနေပါသည်။ ပြန်လည်ကြိုးစားပါ။
                            </p>
                            <p className="text-sm text-signal-ai-blue mt-2">
                                ကျေးဇူးပြုပြီး ခဏအနည်းငယ်စောင့်ပေးပါ
                            </p>
                        </div>
                    ) : <ScoreGauge value={overallScore} max={100} />}
                </div>
                <ReportImages />

                {/* Color Labels */}
                <div className="px-5 py-4">
                    <div className="grid grid-cols-1 gap-3">
                        <div className="flex items-center gap-2">
                            <div className="w-4 h-4 rounded" style={{ backgroundColor: 'transparent', border: '3px solid #0099FF' }}></div>
                            <span className="text-sm text-signal-ai-blue">သွားပိုးပေါက်</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-4 h-4 rounded" style={{ backgroundColor: 'transparent', border: '3px solid #00196C' }}></div>
                            <span className="text-sm text-signal-ai-blue">သွားကျောက်တည်ခြင်း</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-4 h-4 rounded" style={{ backgroundColor: 'transparent', border: '3px solid #C32D87' }}></div>
                            <span className="text-sm text-signal-ai-blue">သွားဖုံးရောင်ရမ်းခြင်း</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-4 h-4 rounded" style={{ backgroundColor: 'transparent', border: '3px solid #00B8B5' }}></div>
                            <span className="text-sm text-signal-ai-blue">သွားကျဲ/မညီညာခြင်း</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex justify-center items-center py-4 flex-col mt-5 mb-10">
                <p className=" text-signal-ai-red text-center my-5"><span className="font-bold text-base">*</span>ဤနေရာတွင် အမှတ်ကိုစခရင်ရှော့ရိုက်ပါ<span className="font-bold text-base">*</span></p>
                <button
                    onClick={goToSummary}
                    className="bg-signal-ai-secondary text-white px-6 py-3 rounded-md font-medium self-center"
                >
                    အသေးစိတ်ကြည့်ရှုရန်
                </button>
            </div>
        </div>
    )
}

export default SignalAIResult